<template>
  <div class="card">
    <div class="card-header">
      <p class="card-header-title">
        <span class="skeleton-line short" />
      </p>
    </div>
    <div class="card-content p-0">
      <table class="table is-fullwidth mb-0">
        <thead>
          <tr>
            <th class="col-number"><span class="skeleton-line" /></th>
            <th><span class="skeleton-line" /></th>
            <th class="col-date"><span class="skeleton-line" /></th>
            <th class="col-date"><span class="skeleton-line" /></th>
            <th class="col-priority"><span class="skeleton-line" /></th>
            <th class="col-amount"><span class="skeleton-line" /></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="i in 4" :key="i">
            <td class="col-number"><span class="skeleton-line" /></td>
            <td>
              <span
                class="skeleton-line"
                :style="{ width: rowWidths[i - 1] }"
              />
            </td>
            <td class="col-date"><span class="skeleton-line" /></td>
            <td class="col-date"><span class="skeleton-line" /></td>
            <td class="col-priority"><span class="skeleton-circle" /></td>
            <td class="col-amount"><span class="skeleton-line" /></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script lang="ts" setup>
const rowWidths = ['85%', '60%', '75%', '90%'];
</script>

<style scoped>
@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

.skeleton-line,
.skeleton-circle {
  display: block;
  background: linear-gradient(
    90deg,
    #e2e8f0 0%,
    #eef2f6 30%,
    #f1f5f9 50%,
    #eef2f6 70%,
    #e2e8f0 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.6s ease-in-out infinite;
  border-radius: 4px;
}

.skeleton-line {
  height: 14px;
  width: 100%;
}

.skeleton-line.short {
  width: 9rem;
}

.skeleton-line.medium {
  width: 6rem;
}

.skeleton-circle {
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 50%;
  margin: 0 auto;
}

.card-header {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.table th,
.table td {
  padding: 0.75rem 1rem;
  vertical-align: middle;
}

.col-number {
  width: 6rem;
}

.col-date {
  width: 10rem;
}

.col-priority {
  width: 5rem;
  text-align: center;
}

.col-amount {
  width: 11rem;
  text-align: right;
}
</style>
